import { render, staticRenderFns } from "./TaxPeriodEdit.vue?vue&type=template&id=0b9fd7f6"
import script from "./TaxPeriodEdit.vue?vue&type=script&lang=js"
export * from "./TaxPeriodEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports